import { Button, InputBase, Paper } from "@mui/material";
import styled from "styled-components";
import SearchIcon from '@mui/icons-material/Search';
import { deviceSpec } from "breakpoints";

export const SearchContainer = styled('div')`
  box-shadow: ${({theme}) => theme.shadows.boxShadowInset};
  background-color: ${({theme}) => theme.name === 'dark-theme' ? `${theme.colors.searchinputbg}30` : theme.colors.searchinputbg};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  border-radius: 8px !important;
  color: ${({ theme }) => theme.colors.textColor};
  border: 1px solid ${({theme}) => theme.colors.dark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.08)'};
  
  @media ${deviceSpec.isTablet} {
    width: 100%;
  }

  @media ${deviceSpec.isMobile} {
    width: auto;
    padding: 8px;
    margin: 8px;
  }
`;

export const SearchBar = styled("div")({
  position: "relative",
  background: "transparent",
  width: "100%",
  fontSize: "12px",
});

export const SearchIconWrapper = styled("div")({
  padding: "0px 16px",
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

export const StyledInputBase = styled(InputBase)({
  height: "40px",
  "&.MuiInputBase-root": { width: "100%" },
  "& .MuiInputBase-input": {
    paddingLeft: "16px",
    width: "100%",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "14px",
    letterSpacing: "0.01em",
  },
});

export const AdvancedSearch = styled(SearchIcon)`
  background: transparent,
  color: ${({ theme }) => theme.colors.textColor};
`;
